import {isArray, mergeWith, uniqWith} from "lodash-es"
import {TAggregation} from "@ui/api/features"
import {LayerId} from "./"
import FeatureService from "./FeatureService"

interface IAggregation {
  addAggregations(aggregations?: TAggregation[]): void
  getAggregation(id: number): TAggregation
  selectAggregation(aggregation_ids: number[]): void
  cancelAggregation(): void
}

class Aggregation implements IAggregation {
  aggregationLayers = [LayerId.BCNLAT, LayerId.BCNSPP, LayerId.NAVLNE, LayerId.RECTRC]
  aggregations: {[id: number]: TAggregation} = {}

  addAggregations(aggregations?: TAggregation[]): void {
    aggregations?.forEach(aggregation => {
      if (aggregation.id in this.aggregations) {
        this.aggregations[aggregation.id] = mergeWith(
          this.aggregations[aggregation.id],
          aggregation,
          (objValue: any, srcValue: any) => {
            if (isArray(objValue) || isArray(srcValue)) {
              return uniqWith(
                [...(objValue || []), ...(srcValue || [])],
                (val1: any, val2: any) => {
                  return val1.id === val2.id
                }
              )
            }
            return objValue
          }
        )
      } else {
        this.aggregations[aggregation.id] = aggregation
      }
    })
  }

  getAggregation(id: number): TAggregation {
    return this.aggregations[id]
  }

  selectAggregation(aggregation_ids: number[]): void {
    Object.values(this.aggregationLayers).forEach(layerId => {
      FeatureService.getLayer(layerId)?.getSource()?.getFeatures().forEach(f => {
        if (f.getProperties().aggregation_ids?.some((aggr_id: number) =>
          aggregation_ids.includes(aggr_id))) {
          f.setProperties({selected: true})
        }
      })
    })
  }

  cancelAggregation(): void {
    Object.values(this.aggregationLayers).forEach(layerId => {
      FeatureService.getLayer(layerId)?.getSource()?.getFeatures().forEach(f => {
        f.setProperties({selected: false})
      })
    })
  }
}

export default new Aggregation() as IAggregation
